"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createReducers = exports.getInitalState = exports.createSetStore = exports.createUseStore = exports.getStore = void 0;
exports.createReducer = createReducer;
const fp_1 = require("lodash/fp");
function createReducer({ initialState, actions }) {
    return function reducer(state = initialState, action) {
        if (actions.hasOwnProperty(action.type)) {
            const handler = actions[action.type];
            return (handler instanceof Function ? handler(state, action.payload) : handler);
        }
        return state;
    };
}
const getStore = () => (path) => (obj) => (0, fp_1.property)(path.split("."))(obj);
exports.getStore = getStore;
const createUseStore = (useSelector) => (path) => useSelector((0, exports.getStore)()(path));
exports.createUseStore = createUseStore;
const createSetStore = (useDispatch) => () => {
    const useDispatchFcn = useDispatch();
    return (...args) => useDispatchFcn({ type: args[0], payload: args[1] });
};
exports.createSetStore = createSetStore;
const getInitalState = (initialConfiguration) => {
    const initialState = {};
    for (const key in initialConfiguration) {
        const initalConfig = initialConfiguration[key];
        initialState[key] = initalConfig.initialState;
    }
    return initialState;
};
exports.getInitalState = getInitalState;
const createReducers = (initialConfiguration) => {
    let reducers = {};
    for (const key in initialConfiguration) {
        const config = initialConfiguration[key];
        const actions = config.actions;
        const initialState = config.initialState;
        reducers[key] = (state = initialState, action) => {
            if (!state)
                return initialState;
            const handler = actions[action.type];
            if (handler) {
                if (typeof handler === "function") {
                    const payload = action === null || action === void 0 ? void 0 : action.payload;
                    return handler(state, payload);
                }
                return handler;
            }
            return state;
        };
    }
    return reducers;
};
exports.createReducers = createReducers;
//# sourceMappingURL=createReducer.js.map